export const media = {
  ssm: "@media (max-width: 375px)",
  sm: "@media (max-width: 640px)",
  md: "@media (max-width: 767px)",
  lg: "@media (max-width: 1024px)",
  xl: "@media (max-width: 1280px)",
  xxl: "@media (max-width: 1536px)",
  "3xl": "@media (max-width: 1599px)"
};
